import React, { useMemo } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import { DateRange, Build } from "@mui/icons-material";

const YearConditionFilter = ({
  yearRange,
  // condition,
  // conditions,
  onYearRangeChange,
  // onConditionChange,
  filterOptions, // Agregar filterOptions como prop
}) => {
  const currentYear = new Date().getFullYear();

  // Generar años basado en filterOptions si está disponible, sino usar rango por defecto
  const years = useMemo(() => {
    if (filterOptions?.yearRange) {
      const { min, max } = filterOptions.yearRange;
      return Array.from({ length: max - min + 1 }, (_, i) => min + i);
    } else {
      // Fallback: rango más amplio que incluya años anteriores a 2000
      const minYear = 1990;
      return Array.from(
        { length: currentYear - minYear + 1 },
        (_, i) => minYear + i
      );
    }
  }, [filterOptions?.yearRange, currentYear]);

  // 🔧 FIX: Validar y ajustar yearRange para evitar valores fuera de rango
  const validatedYearRange = useMemo(() => {
    if (!yearRange || !Array.isArray(yearRange)) {
      return filterOptions?.yearRange
        ? [filterOptions.yearRange.min, filterOptions.yearRange.max]
        : [1990, currentYear];
    }

    const [min, max] = yearRange;
    const availableYears = years;

    // Validar que los valores estén dentro del rango disponible
    const validMin = availableYears.includes(min) ? min : availableYears[0];
    const validMax = availableYears.includes(max)
      ? max
      : availableYears[availableYears.length - 1];

    return [validMin, validMax];
  }, [yearRange, years, filterOptions?.yearRange, currentYear]);

  const handleYearChange = (type, value) => {
    if (type === "min") {
      onYearRangeChange([value, validatedYearRange[1]]);
    } else {
      onYearRangeChange([validatedYearRange[0], value]);
    }
  };

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          <DateRange sx={{ fontSize: 16, mr: 0.5 }} />
          Año de fabricación
        </Typography>

        <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
          <FormControl size="small" sx={{ flex: 1 }}>
            <Select
              value={validatedYearRange[0]}
              onChange={(e) => handleYearChange("min", e.target.value)}
              displayEmpty
              MenuProps={{ disableScrollLock: true }}
            >
              <MenuItem value="" disabled>
                Desde
              </MenuItem>
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography variant="body2" color="text.secondary">
            -
          </Typography>

          <FormControl size="small" sx={{ flex: 1 }}>
            <Select
              value={validatedYearRange[1]}
              onChange={(e) => handleYearChange("max", e.target.value)}
              displayEmpty
              MenuProps={{ disableScrollLock: true }}
            >
              <MenuItem value="" disabled>
                Hasta
              </MenuItem>
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          <Build sx={{ fontSize: 16, mr: 0.5 }} />
          Estado
        </Typography>
        <FormControl fullWidth>
          <Select
            value={condition}
            onChange={(e) => onConditionChange(e.target.value)}
            size="small"
            MenuProps={{ disableScrollLock: true }}
          >
            {conditions.map((cond) => (
              <MenuItem key={cond} value={cond}>
                {cond === "Todas"
                  ? "Todas las condiciones"
                  : cond
                      .replace("-", " ")
                      .replace(/\b\w/g, (l) => l.toUpperCase())}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box> */}

      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default YearConditionFilter;
